import { TransactionCardSpend, TransactionStatus } from '@/features/Transactions/transactions.types'
import React from 'react'
import styles from '@/features/Transactions/ui/MobileTxRow/MobileTxRow.module.scss'
import { TransactionIcon } from '@/features/Transactions/ui/MobileTxRow/Common/TransactionIcon'
import { TransactionDetails } from '@/features/Transactions/ui/MobileTxRow/Common/TransactionDetails'
import { formatSimpleToken, formatTokenAmount } from '@/shared/helpers/crypto'
import classnames from 'classnames'
import { Flex } from 'antd'
import { mints } from '@/shared/constants/mints'

export function CardSpend({ transaction, onClick, withoutDate }: {
  onClick: () => void;
  transaction: TransactionCardSpend;
  withoutDate: boolean;
}) {
  const { merchantName, amount, originalAmount, type } = transaction.data
  const { createdAt, status } = transaction

  const iconType = 'SPENDING'
  const isError = status === TransactionStatus.ERROR_SEND || status === TransactionStatus.FAILED

  return (
    <div className={classnames(styles.txRow)}>
      <Flex onClick={onClick} gap={12} align="center">
        <TransactionIcon
          type={status === 'IN_PROGRESS' ? 'IN_PROGRESS' : iconType}
          isLoading={status === 'IN_PROGRESS'}
          isError={isError}
        />
        <TransactionDetails
          title={merchantName}
          createdAt={createdAt}
          status={status}
          withoutDate={withoutDate}
          isError={isError}
          txType={type}
        />
        <div className={styles.txAmount}>
          <p className={classnames(
            styles.txTokenAmount,
            isError && styles.errorTxGrey,
          )}
          >
            {typeof amount === 'string' ? `0 ${mints[transaction.data.amount.mint]}` : `${formatSimpleToken(originalAmount.amount, 4)} ${originalAmount.currency}`}
          </p>
          <p className={classnames(styles.txUsdAmount, isError && styles.errorTxGrey)}>
            {typeof amount === 'string' ? '$0' : formatTokenAmount(transaction.data.amount, true)}
          </p>
        </div>
      </Flex>
    </div>
  )
}
